<div *ngIf="overlay == 'normal'">
<img
  alt="Logo"
  src="{{_normalLogoURL}}"
  class="{{ classes }} d-block theme-light-show"
/>
<img
  alt="Logo"
  src="{{_lightLogoURL}}"
  class="{{ classes }} d-block theme-dark-show"
/>
</div>


<div *ngIf="overlay == 'white'">
    <img
      alt="Logo"
      src="{{_lightLogoURL}}"
      class="{{ classes }} d-block theme-light-show"
    />
    <img
      alt="Logo"
      src="{{_lightLogoURL}}"
      class="{{ classes }} d-block theme-dark-show"
    />
    </div>